<template>
  <div class="con">
    <div class="imgbg"></div>
    <div class="newslist">
      <ul>
        <li>
          <img src="../../img/img1.png" class="img">
          <div class="txt">
            <h1>中秋团聚，干货全在这儿！</h1>
            <p>“明月几时有，把酒问青天。不知天上宫阙，今夕是何年？”<br>
              又一个中秋佳节即将来临。今年的中秋恰逢国庆，这无疑给了我们更多的时间可以跟家人团聚。“月是故乡明”，“每逢佳节倍思亲”，古往今来，那么多的文人墨客用月亮寄托对亲人的思念。中秋佳节，亲友之间的礼尚往来，相互奔走祝福就更显现出节日的氛围。</p>
            <p class="bottomTxt">
              <span class="ltxt" @click="dcodeShow"> ¥ 2元／条，付费查看更多 ></span>
              <span class="rtxt">2020-09-15</span>
            </p>
          </div>
        </li>
        <li>
          <img src="../../img/img2.png" class="img">
          <div class="txt">
            <h1>这届学生网友真心有才！探索不一样的高校校徽！</h1>
            <p>夏天已经悄悄过去，秋季也将马上来临，各大高校学生在经历了漫长的寒假加暑假之后，终于迎来了来校报到的日子~<br>此时此刻，困在家里的神兽终于走出家门，在跟父母保证“一定保持安全距离”之后，头也不回地，一猛子扎进校园，扎进属于他们自己的天地！</p>
            <p class="bottomTxt">
              <span class="ltxt" @click="dcodeShow"> ¥ 2元／条，付费查看更多 ></span>
              <span class="rtxt">2020-08-31</span>
            </p>
          </div>
        </li>
        <li>
          <img src="../../img/img3.png" class="img">
          <div class="txt">
            <h1>高考之后报志愿的那些事儿</h1>
            <p>由于考试政策等各方面情况的不断调整与变化，本文所提供的考试信息仅供参考，请以权威部门公布的正式信息为准。<br>填完高考志愿后，家长和同学们进入了焦急等待录取通知单的阶段。在这个阶段，下面这6件事是我们必须注意的：</p>
            <p class="bottomTxt">
              <span class="ltxt" @click="dcodeShow"> ¥ 2元／条，付费查看更多 ></span>
              <span class="rtxt">2020-07-08</span>
            </p>
          </div>
        </li>
        <li>
          <img src="../../img/img4.png" class="img">
          <div class="txt">
            <h1>小粽子里的大千秋</h1>
            <p>端午节到了，甜、咸粽子大战又吹响号角啦！你喜欢什么口味的粽子？其实，无论是甜粽子还是咸粽子，都是美味诱人的好粽子！何不多多尝试呢？要知道，粽子的种类有很多，可不止口味之分。快来看看，这里有没有你不认识的粽子</p>
            <p class="bottomTxt">
              <span class="ltxt" @click="dcodeShow"> ¥ 2元／条，付费查看更多 ></span>
              <span class="rtxt">2020-06-24</span>
            </p>
          </div>
        </li>
      </ul>
    </div>
    <div class="showDcode" v-if="showDcode">
      <div class="bg" @click="hideDcode"></div>
      <div class="popcon">
        <p class="top">¥ 2元／条</p>
        <img src="../../img/dcode3.png" class="dcodeimg">
        <p>通过支付宝二维码付费后可查看更多资讯</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      dcode: '',
      showDcode: false
    }
  },
  methods: {
    dcodeShow(){
      this.showDcode = true

    },
    hideDcode(){
      this.showDcode = false
    }
  },
  mounted: function () {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .con {}
  .con .imgbg {width: 100%; height: 330px; background: url("../../img/bg1.jpg") center no-repeat; background-size: 100%}
  .newslist {margin: 20px auto; width: 1200px;}
  .newslist li {padding: 20px 0; border-bottom: 1px solid #e0e0e0;}
  .newslist li .img {float: left; width: 290px;}
  .newslist li .txt {width: 885px; float: right; font-size: 14px; line-height: 24px; color: #666}
  .newslist li:after {content: ""; display: block; clear: both}
  .newslist li h1 {font-size: 18px; line-height: 40px; color: #333}
  .newslist li .bottomTxt {margin-top: 30px}
  .newslist li .bottomTxt .ltxt {float: left; color: #007aff; cursor: pointer}
  .newslist li .bottomTxt .rtxt {float: right; color: #999}
  .showDcode {position: fixed; left: 0; top: 0; width: 100%; height: 100%; z-index: 99}
  .showDcode .bg {position: absolute; left: 0; top: 0; width: 100%; height: 100%; background: #000; opacity: .7}
  .showDcode .popcon {width: 400px; display: flex; justify-content: center; align-items: center; flex-direction: column; position: absolute; left: 50%; top: 50%; -webkit-transform: translate(-50%,-50%); background: #fff; border-radius: 10px; padding: 40px 0}
  .showDcode .popcon .dcodeimg {width: 220px; margin: 20px 0}
  .showDcode .popcon .top {color: #007aff; font-size: 16px}
</style>



// WEBPACK FOOTER //
// src/components/children/consultation.vue